import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';


Vue.use(Vuex);

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((moduleArr, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
    moduleArr[moduleName] = value.default;
  return moduleArr;
}, {});

const store = new Vuex.Store({
  modules,
  getters
});

export default store;
